// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_YLoVc{display:flex}", ""]);
// Exports
exports.locals = {
	"container": "container_YLoVc"
};
module.exports = exports;
